import React from "react";
import styled from "styled-components";
import { FaGithub, FaLinkedin, FaFacebook, FaWhatsapp } from "react-icons/fa";
import { TbSend } from "react-icons/tb";
import { FaDownload } from "react-icons/fa6";

const Section = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #f8f9fa;
  padding: 2rem;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  text-align: center;
  max-width: 1100px;
  width: 100%;

  @media (min-width: 768px) {
    flex-direction: row;
    text-align: left;
    gap: 3rem;
    justify-content: space-between;
  }
`;

const Info = styled.div`
  flex: 1;
`;

const Name = styled.h2`
  font-size: 2.5rem;
  font-weight: bold;
  color: #222;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Title = styled.h3`
  font-size: 1.3rem;
  font-weight: 500;
  color: #555;
  border-bottom: 2px solid #222;
  width: max-content;
  margin: 0.5rem 0 1.2rem;
`;

const Description = styled.p`
  font-size: 1rem;
  color: #666;
  max-width: 500px;
  line-height: 1.6;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 2rem;
  justify-content: center;

  @media (min-width: 768px) {
    justify-content: flex-start;
  }
`;

const TalkButton = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #222;
  color: #fff;
  padding: 12px 24px;
  font-size: 1rem;
  text-decoration: none;
  border-radius: 10px;
  width: max-content;
  transition: background 0.3s ease;

  &:hover {
    background: #005bb5;
  }
`;

const ResumeButton = styled.a`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: #000;
  color: #fff;
  padding: 12px 24px;
  font-size: 1rem;
  text-decoration: none;
  border-radius: 10px;
  width: max-content;
  transition: background 0.3s ease, transform 0.2s;

  &:hover {
    background: #444;
    transform: scale(1.05);
  }
`;

const ProfileImage = styled.img`
  width: 190px;
  height: 200px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #000;
  flex-shrink: 0;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  margin-top: 1.5rem;

  @media (min-width: 768px) {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    flex-direction: column;
    margin-top: 0;
  }
`;

const SocialIcon = styled.a`
  font-size: 1.5rem;
  color: #333;
  transition: color 0.3s ease, transform 0.2s;

  &:hover {
    color: #0073e6;
    transform: scale(1.1);
  }
`;

function Home() {
  return (
    <Section id="home">
      <Content>
        <Info>
          <Name>
            Irene Muthoki{" "}
            <span role="img" aria-label="wave">
              👋
            </span>
          </Name>
          <Title>Software Developer</Title>
          <Description>
            I am a results-driven Software Developer with 3 years of experience
            in full-stack development, specializing in building scalable and
            efficient web applications using React, Next.js, TypeScript, and
            Node.js. I create intuitive user interfaces, integrate RESTful APIs,
            and craft secure backend logic while staying updated with the latest
            technologies.
          </Description>

          <ButtonContainer>
            <TalkButton href="mailto:irenemuthoki50@gmail.com">
              Let&apos;s Talk <TbSend />
            </TalkButton>

            <ResumeButton href="/assets/Irene-Muthoki_Resume.pdf" download>
              Download Resume <FaDownload />
            </ResumeButton>
          </ButtonContainer>

          <SocialLinks>
            <SocialIcon
              href="https://github.com/Irenemuthoki"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGithub />
            </SocialIcon>
            <SocialIcon
              href="https://www.linkedin.com/in/irene-muthoki-1076a7231?"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </SocialIcon>
            <SocialIcon
              href="https://wa.me/254705953882"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaWhatsapp />
            </SocialIcon>
            <SocialIcon
              href="https://www.facebook.com/share/1B1t6Vw7iu/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook />
            </SocialIcon>
          </SocialLinks>
        </Info>

        <ProfileImage src="/profile.jpg" alt="Irene Muthoki" />
      </Content>
    </Section>
  );
}

export default Home;
